module.exports = __webpack_public_path__ + "img/ep6-6.01bcc2b0.png";